var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7068_15646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4333 12.9995L12.6333 17.3329L19.5666 8.66621M13.5 25.1329C11.9066 25.1329 10.3288 24.819 8.85675 24.2093C7.38466 23.5995 6.04709 22.7058 4.92041 21.5791C3.79372 20.4524 2.89999 19.1149 2.29023 17.6428C1.68048 16.1707 1.36664 14.5929 1.36664 12.9995C1.36664 11.4062 1.68048 9.8284 2.29023 8.35632C2.89999 6.88424 3.79372 5.54667 4.92041 4.41998C6.04709 3.2933 7.38466 2.39956 8.85675 1.78981C10.3288 1.18005 11.9066 0.866211 13.5 0.866211C16.7179 0.866211 19.8041 2.14454 22.0795 4.41998C24.355 6.69542 25.6333 9.78158 25.6333 12.9995C25.6333 16.2175 24.355 19.3037 22.0795 21.5791C19.8041 23.8545 16.7179 25.1329 13.5 25.1329Z",
    stroke: "url(#paint0_linear_7068_15646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7068_15646",
    x1: 13.5,
    y1: 0.866211,
    x2: 19.24,
    y2: 31.9136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7068_15646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmark);
export default __webpack_public_path__ + "static/media/tickmark.63718a9b38a2208355efe9288227b43f.svg";
export { ForwardRef as ReactComponent };